import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '@api-client/types';
import { ProductInterface } from '@interfaces/Product.interface';

export class ApiTaskProducts extends BaseApiClient {
  async getFilteredTaskProducts(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<ProductInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.q = searchTerm;
      }
      this.client
        .getList('/task-products', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta.current_page,
                perPage: res.data.meta.per_page,
                total: res.data.meta.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { taskProductsQueryKeys } from './query-keys';
export type { TaskProductsFilteredListParams } from './query-keys';
export { useTaskProductsFilteredListQuery } from './use-task-products-queries';
